export const CITIES = [
  {
    name: 'Karachi',
    value: 'Karachi',
    province: 'Sindh',
  },
  {
    name: 'Hyderabad',
    value: 'Hyderabad',
    province: 'Sindh',
  },
  {
    name: 'Sukkur',
    value: 'Sukkur',
    province: 'Sindh',
  },
  {
    name: 'Larkana',
    value: 'Larkana',
    province: 'Sindh',
  },
  {
    name: 'Mirpur Khas',
    value: 'Mirpur Khas',
    province: 'Sindh',
  },
  {
    name: 'Lahore',
    value: 'Lahore',
    province: 'Punjab',
  },
  {
    name: 'Faisalabad',
    value: 'Faisalabad',
    province: 'Punjab',
  },
  {
    name: 'Rawalpindi',
    value: 'Rawalpindi',
    province: 'Punjab',
  },
  {
    name: 'Multan',
    value: 'Multan',
    province: 'Punjab',
  },
  {
    name: 'Gujranwala',
    value: 'Gujranwala',
    province: 'Punjab',
  },
  {
    name: 'Sialkot',
    value: 'Sialkot',
    province: 'Punjab',
  },
  {
    name: 'Bahawalpur',
    value: 'Bahawalpur',
    province: 'Punjab',
  },
  {
    name: 'Peshawar',
    value: 'Peshawar',
    province: 'Khyber Pakhtunkhwa',
  },
  {
    name: 'Mardan',
    value: 'Mardan',
    province: 'Khyber Pakhtunkhwa',
  },
  {
    name: 'Mingora',
    value: 'Mingora',
    province: 'Khyber Pakhtunkhwa',
  },
  {
    name: 'Kohat',
    value: 'Kohat',
    province: 'Khyber Pakhtunkhwa',
  },
  {
    name: 'Abbottabad',
    value: 'Abbottabad',
    province: 'Khyber Pakhtunkhwa',
  },
  {
    name: 'Quetta',
    value: 'Quetta',
    province: 'Balochistan',
  },
  {
    name: 'Gwadar',
    value: 'Gwadar',
    province: 'Balochistan',
  },
  {
    name: 'Turbat',
    value: 'Turbat',
    province: 'Balochistan',
  },
  {
    name: 'Khuzdar',
    value: 'Khuzdar',
    province: 'Balochistan',
  },
  {
    name: 'Gilgit',
    value: 'Gilgit',
    province: 'Gilgit-Baltistan',
  },
  {
    name: 'Skardu',
    value: 'Skardu',
    province: 'Gilgit-Baltistan',
  },
  {
    name: 'Hunza',
    value: 'Hunza',
    province: 'Gilgit-Baltistan',
  },
];
